import React, { Component } from 'react';
import radium, { Style } from 'radium';
import $j from 'jquery';
import EditableTextView from '../../../../../../components/EditableTextView';
import utils from '../../../../../../utils/utils';
// import Relay from 'react-relay/classic';

const editorOptions = {
  /*   paste: {
    forcePlainText: false,
    cleanPastedHTML: false
  }, */
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
      'unorderedlist',
      'orderedlist'
    ]
  }
};

class ListItem extends Component {
  state = {
    checked: false
  };

  UNSAFE_componentWillMount() {
    this.listHtml = this.props.item.paragraph;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.listHtml = nextProps.item.paragraph;
  }

  onListTextChange = (itemId, dispatch) => (html) => {
    this.listHtml = html;
    dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      paragraph: html
    });
  };

  addNewListItem = (index) => {
    this.props.addNewListItem(index, {
      _id: utils.getNewObjectId(),
      number: index + 1,
      paragraph: ''
    });
  };

  removeListItem = (index, itemId) => {
    this.props.removeListItem(index, itemId);
  };

  toggleCheckbox = () => {
    this.setState({
      checked: !this.state.checked
    });
  };

  /*  renderVarientBullet = (item, variant) => {
    if (variant === 'checkboxes') {
      return (
        <div className={'block-list__icon brand--background ' + (this.state.checked && 'block-list__icon--checked')}>
          <i className="icon icon-checkmark-valid">
          </i>
          <div className="block-list__icon-hitarea" onClick={this.toggleCheckbox}></div>
        </div>
      );
    }
    return null;
  }; */

  getVariantClass = (variant) => {
    switch (variant) {
      case 'numbered':
        return 'brand--beforeBackground brand--beforeBorder';
      case 'checkboxes':
        return 'brand--beforeBorder';
      case 'bulleted':
        return 'brand--beforeColor brand--beforeBorder brand--beforeBackground';
      default:
        return '';
    }
  };

  onKeyDown = (index, itemId) => (e) => {
    if (e && e.keyCode === 13 && !e.shiftKey) {
      // e.persist();
      // console.log('enter pressed');
      this.addNewListItem(index + 1);
      e.preventDefault();
      e.stopPropagation();

      /* const newEvent = $j.Event('keypress');
      newEvent.which = 9; // Character 'A'
      $j(e.target).trigger(newEvent); */
      return;
    }

    if (e && e.keyCode === 8 && (!this.listHtml || this.listHtml === '')) {
      this.removeListItem(index, itemId);
    }
  };

  render() {
    const styles = ListItem.styles;
    const { item, variant, dispatch, editable, index } = this.props;

    return (
      <li className={'block-list__item ' + this.getVariantClass(variant)} data-number={index + 1}>
        <span className="block-list__content brand--body brand--linkColor">
          <EditableTextView
            text={item.paragraph}
            placeholder="Enter text here..."
            wrapperClassName="block-list__content brand--body brand--linkColor"
            editable={editable}
            itemId={item._id}
            onChange={this.onListTextChange(item._id, dispatch)}
            onKeyDown={this.onKeyDown(index, item._id)}
            editorOptions={editorOptions}
          />
        </span>
        {/* this.renderVarientBullet(item, variant) */}
      </li>
    );
  }
}

export default radium(ListItem);
